export enum Region {
    NA = 1,
    US = 2,
    CA = 3,
    EU = 4,
    External = 5,
}
export interface WarehouseModel {
    id: number;
    name: string;
    code: string;
    color: string;
    availableQty: number;
    unavailableQty: number;
}

export const createWarehouse = (): WarehouseModel => ({
    id: 0,
    name: "",
    code: "",
    color: "",
    availableQty: 0,
    unavailableQty: 0
});